module.exports = __webpack_public_path__ + "img/pay.2646d716.jpg";